// ============================================
// FILE: src/pages/supplier/Dashboard.jsx
// All cards removed as per requirement.
// ============================================
import React from 'react';
import Navbar from '../../components/Navbar';

const SupplierDashboard = () => {
  return (
    <div className="min-h-screen">
      <Navbar userType="supplier" />
      {/* Dashboard is intentionally empty — all cards removed as per requirement */}
    </div>
  );
};

export default SupplierDashboard;